export default {
  data(){
      return{
  cn: {
    /* ===================== NAV_NAME ======================*/

      nav_name: "云翰虹章",

    /* ===================== HOME ======================*/

    nav_home_title: "首页",

      /* ===================== NAV INDUSTRY AREA ======================*/
    nav_industry_area_title: "行业领域",
    nav_industry_area: [
      {
        title: "影视",
        description: "Descriptions",
        link: { path: '/industryarea', hash: '#film_television' }
      },
      {
        title: "文化旅游",
        description: "Descriptions",
        link: { path: '/industryarea', hash: '#culture_tour' }
      },
      {
        title: "数字资产",
        description: "Descriptions",
        link: { path: '/industryarea', hash: '#digital_assets' }
      },
      {
        title: "AIGC",
        description: "Descriptions",
        link: { path: '/industryarea', hash: '#aigc' }
      }
    ],

    /* ===================== PLAN AND CASES ======================*/

    plan_and_cases_title: "方案与案例",

    /* ===================== News ======================*/

    news_title: "新闻资讯",

    /* ===================== News ======================*/

    about_us_title: "关于我们",

    /* ===================== News ======================*/

    // contact_us_title: "联系我们",
    
  }
}
}
};
